import { ChangeEvent } from 'react'

import { FieldValidation, TextField } from '@cash-me/react-components'
import { useFormik } from 'formik'

import { applyMask } from 'utils/masks/applyMask'

import { FormDataType, SubdelegatedRegistrationStepOneValues } from './form.model'

type InputFactoryProps = {
  inputProps: FormDataType
  formikContext: Pick<
    ReturnType<typeof useFormik<SubdelegatedRegistrationStepOneValues>>,
    'values' | 'handleBlur' | 'handleChange' | 'setFieldTouched' | 'setFieldValue' | 'errors' | 'touched'
  >
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  loading?: boolean
  validation?: FieldValidation
}

export function inputFactory({ inputProps, formikContext, onChange, loading, validation }: InputFactoryProps) {
  const { id, label, mask, format, disabled, maxLength, className } = inputProps
  const { values, errors, touched, handleBlur, handleChange, setFieldTouched, setFieldValue } = formikContext

  return (
    <div {...(className && { className })} key={id}>
      <TextField
        id={id}
        name={id}
        label={label}
        value={values[id]}
        variant="outline"
        noMargin
        disabled={disabled}
        maxLength={maxLength}
        loading={loading}
        onChange={
          onChange ??
          (event => {
            setFieldTouched(id, true)
            if (format) {
              setFieldValue(id, format(event.target.value))
              return
            }
            if (mask) {
              setFieldValue(id, applyMask(event.target.value, mask))
              return
            }
            handleChange(event)
          })
        }
        onBlur={handleBlur}
        {...(mask && { mask })}
        validation={
          validation ?? {
            ...(errors[id] && touched[id] && { invalid: errors[id] }),
            ...(!errors[id] && touched[id] && { valid: '' })
          }
        }
        required
      />
    </div>
  )
}
